'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { groupedFeesByProductLevelSelector } from '../../selectors/PricingSelectors';
import RequiredOnboardingSubtext from './RequiredOnboardingSubtext';

const RequiredOnboardingSubtextContainer = ({
  queryParamTerm,
  skuIds
}) => {
  const activeCurrencyCode = useSelector(activeCurrencySelector); // Group fees by product level if possible

  const feesMap = useSelector(state => groupedFeesByProductLevelSelector(state, {
    skuIds,
    queryParamTerm
  }));
  return Object.keys(feesMap).map(langKey => /*#__PURE__*/_jsx(RequiredOnboardingSubtext, {
    pricingInfo: feesMap[langKey],
    currencyCode: activeCurrencyCode,
    langKey: langKey
  }, langKey));
};

RequiredOnboardingSubtextContainer.propTypes = {
  queryParamTerm: PropTypes.string,
  skuIds: PropTypes.arrayOf(PropTypes.number).isRequired
};
export default RequiredOnboardingSubtextContainer;